import { useContext } from "react";
import { AuthenticationContext } from "../Contexts";
export function useAuthentication() {
    const { user, TIENE_PERMISO } = useContext(
        AuthenticationContext
    );
    return {
        usuario: user,
        TIENE_PERMISO,
    };
}
